import React from "react";

const PopularArticlesNearMe = (props) => {

    const blogInfo = props.blogInfo;
    const teaser = stripHtml(blogInfo.teaser)

    function stripHtml(html) {
        return html.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, ' ')
    }

    return (
        <><div className="popularBlogContainer">
            <div className="row">
                <div className="col-lg-4">
                    <a href={blogInfo.url}>
                        <img className="blog-img" src={blogInfo.image?.path} alt={blogInfo.image?.alt} loading="lazy"/>
                    </a>
                </div>
                <div className="col-lg-8">
                    <div className="title row">
                        <a href={blogInfo.url}><span>{blogInfo.title}</span></a>
                    </div>
                    <div className="text">
                        <p itemprop="description">{teaser}</p>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default PopularArticlesNearMe;